import { Route } from "react-router-dom";
import MyProfiles from "@pages/profiles/my-profiles";
import Profiles from "@pages/profiles";

export const profileRoutes = [
  <Route key="my-profile" path="/profiles/me" element={<MyProfiles />} />,
  <Route key="profiles" path="/profiles" element={<Profiles />} />,
];
